import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.modular';
import DriverApp from './DriverApp';
import { initNativeApp } from './nativeApp';

// Surface routing: env var wins (subdomain deploys), pathname is fallback for local dev
const surface = process.env.REACT_APP_SURFACE;
const isDriverRoute = surface === 'driver' || (!surface && window.location.pathname.startsWith('/drivers'));
const isAdminSurface = surface === 'admin';

initNativeApp().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      {isAdminSurface
        ? null /* Admin surface — placeholder for admin.loaddashservices.com */
        : isDriverRoute
        ? <DriverApp />
        : <App />}
    </React.StrictMode>
  );
});

// PWA service worker registration — minimal, for installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Capture install prompt for future use
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
});
